import ImageView from "../QuizBank/ImageView.vue"
import ReportIssue from "../../../components/ReportIssue.vue"
import { socialvue } from "../../../config/pluginInit.js"
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import { QuizAnswers } from "../../../FackApi/api/quizAnswers.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { base64decode, base64encode } from "nodejs-base64"
import cacheLs from "../../../store/cacheLs.js"
import moment from "moment"
import chatbot from "./chatbot.vue"
import pdfLogo from "../../../assets_gide/img/logo/pdfLogo.png"
import "katex/dist/katex.min.css"

// NOT IN USE BUT CAN BE ENABLED IN FUTURE
const NUMERIC_ANS_MAX_LEN_POSITIVE = 5
const NUMERIC_ANS_MAX_LEN_NEGATIVE = 6

export default {
  name: "QuestionQuizFullPage",
  components: {
    ImageView,
    ReportIssue,
    chatbot
  },
  data () {
    return {
      questionIndex: 0,
      questionList: [],
      userResponses: {},
      userTimeSpentAnalytics: {}, // Holds the Final Q wise timespent data
      update: 0,
      examDetail: {},
      timer: { min: 0, sec: 0 },
      appId: null,
      quizSessionId: null, // same as aprs_id,

      showSubmitModal: false,
      gridAnsweredQuestions: 0,
      gridUnansweredQuestions: 0,

      showCalculatorModal: false,
      showModelImageView: false,
      showSubmitLoader: false, // Controls the visibility of the full-screen loader,
      showReportIssueModalBox: false,
      exitingQuiz: false,

      desmosCalc: "https://www.desmos.com/calculator?lang=en",

      propImageUrl: null,

      timerFunctionRef: null,
      handleTimerVisibilityChange: null,

      showToast: false,
      toastTitle: "Quiz Response",
      toastMsg: null,
      toastVariant: "default",

      toBeReviewedQuestionIndexList: [],
      isChatBotOpen: true,

      cvAnswerImgAttachmentLabel: "Click here to upload your answer",
      allowedExtensions: "application/pdf,image/png,image/jpg,image/jpeg,image/gif,image/webp,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
      answer_image_preview: null,
      answer_image_name: null,
      pdfLogo: pdfLogo,
      showAnswerModal: false,
      refreshComponent: 0,
      tabSwitchCount: 0,
      maxTabSwitchesAllowed: 2,
      showTabSwitchWarningModal: false,
      tabSwitchWarningMessage: "",
      isExamSubmitted: false,
      WarningMessage: `Warning 1/1: Navigating away or switching tabs during the test is prohibited. Doing this again will foreclose this attempt and return you to the attempt list screen`,
      appChainIds: null,
      ALLOWWINDOWOPEN: false,
      isMockExam: false,
      isGPathExam: false
    }
  },
  props: {
    propAppId: {
      type: String,
      default: null
    },
    propModalTitle: {
      type: String,
      default: null
    },
    propModuleObject: {
      type: Object,
      default: null
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    },
    gidePlusData () {
      return this.$store.getters["Paygw/myPlanState"]
    }
  },
  async mounted () {
    socialvue.index()
    await this.initializeQuiz()

    this.isMockExam = !!(this.examDetail.app_name && this.examDetail.app_name.toLowerCase().includes("mock"))
    this.isGPathExam = !!(this.examDetail.app_id && this.examDetail.app_id.toLowerCase().includes("gpath"))

    if (this.isMockExam) {
      document.addEventListener("visibilitychange", this.handleVisibilityChange)
      window.addEventListener("blur", this.handleWindowBlur)
      window.addEventListener("beforeunload", this.handleBeforeUnload)
    }
    else if (this.isGPathExam) {
      window.addEventListener("beforeunload", this.handleBeforeUnload)
    }

    this.handleTimerVisibilityChange = () => {
      if (!document.hidden) {
        this.reCalculateTimer()
      }
    }
    document.addEventListener("visibilitychange", this.handleTimerVisibilityChange)
  },
  beforeDestroy () {
    if (this.timerFunctionRef) {
      clearTimeout(this.timerFunctionRef)
    }

    if (this.isMockExam) {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange)
      window.removeEventListener("blur", this.handleWindowBlur)
      window.removeEventListener("beforeunload", this.handleBeforeUnload)
    }
    else if (this.isGPathExam) {
      window.removeEventListener("beforeunload", this.handleBeforeUnload)
    }

    document.removeEventListener("visibilitychange", this.handleTimerVisibilityChange)
  },
  beforeRouteLeave (to, from, next) {
    if (!this.examDetail) {
      // User is not in the middle of the quiz
      return next()
    }

    let x = 0 // Gets called on the Back Arrow, Show the Alert instead of the Modal for now
    if (x == 1 && this.examDetail.app_name.toLowerCase().includes("mock")) {
      if (this.exitingQuiz || this.isExamSubmitted) {
        return next()
      }

      this.handleQuitAttempt()
      next(false)
    }
    else {
      if (this.exitingQuiz) {
        return next()
      }

      const answer = window.confirm("Navigating away from an active assessment is restricted. Please complete your test before exiting.. If you exit, you shall forefeit this attempt. Do you want to exit ?")
      if (answer) {
        next()
      }
      else {
        next(false)
      }
    }
  },
  methods: {
    /**
     * handleQuitAttempt
     * Opens warning modal box when clicking the back arrow
     */
    handleQuitAttempt () {
      let x = 0 // Not taking this live
      if (x == 1 && this.examDetail.app_name.toLowerCase().includes("mock")) {
        this.tabSwitchWarningMessage = "Navigating away from an active assessment is restricted. Please complete your test before exiting."
        this.showTabSwitchWarningModal = true
        return
      }

      this.goToQuizDetail()
    },
    /**
     * handleVisibilityChange
     * Tracks tab switching or window minimization during an assessment
     * Deprecated: On Tab Switch handleVisibilityChange & handleWindowBlur both get called and user is thrown out, which is not desirable
     */
    handleVisibilityChange () {
      if (document.hidden && !this.isExamSubmitted && !this.exitingQuiz) {
        // this.registerCheatViolation("Tab switch or window minimization detected.")
        console.log("XXX handleVisibilityChange: Tab switch or window minimization detected. this.ALLOWWINDOWOPEN =", this.ALLOWWINDOWOPEN)
      }
    },
    /**
     * handleWindowBlur
     * Tracks focus loss from the main quiz window
     */
    handleWindowBlur () {
      if (!this.isExamSubmitted && !this.exitingQuiz && !this.showSubmitModal && !this.showAnswerModal && !this.showCalculatorModal) {
        console.log("XXX handleWindowBlur: Focus lost from the assessment window. this.ALLOWWINDOWOPEN =", this.ALLOWWINDOWOPEN)
        if (!this.ALLOWWINDOWOPEN) {
          this.registerCheatViolation("Focus lost from the assessment window.")
        }
        this.ALLOWWINDOWOPEN = false
      }
    },
    /**
     * handleBeforeUnload
     * Intercepts tab closing or hard page refreshes
     */
    handleBeforeUnload (event) {
      const submissionInProgress = this.showSubmitLoader || (this.isGPathExam && this.isExamSubmitted)

      if (submissionInProgress) {
        const warningMsg = "Submission is in progress. Please donot refresh."
        event.preventDefault()
        event.returnValue = warningMsg
        return warningMsg
      }

      if (!this.isExamSubmitted && !this.exitingQuiz) {
        const warningMsg = "Your assessment progress will be submitted automatically if you leave."
        event.preventDefault()
        event.returnValue = warningMsg
        return warningMsg
      }
    },
    /**
     * registerCheatViolation
     * Registers violations: gives 1 warning, redirects directly to home on second violation without submitting
     */
    async registerCheatViolation (reason) {
      console.log("XXX registerCheatViolation", reason)

      let x = 1 // Not taking this live at the moment
      if (x == 1) {
        return
      }

      if (this.isExamSubmitted || this.exitingQuiz || this.ALLOWWINDOWOPEN) return

      this.tabSwitchCount++

      if (this.tabSwitchCount >= this.maxTabSwitchesAllowed) {
        this.exitingQuiz = true
        this.tabSwitchWarningMessage = `Proctoring violation limit reached (${reason}). Redirecting to home page...`
        this.showTabSwitchWarningModal = true

        await this.markAttemptAsCheated()

        setTimeout(() => {
          let link = `/attempt_list/${this.examDetail.app_parent}/${this.examDetail.app_parent}`
          this.destroyQuiz()
          this.$router.replace(link)
        }, 3000)
      }
      else {
        this.tabSwitchWarningMessage = this.WarningMessage
        this.showTabSwitchWarningModal = true
      }
    },
    /**
     * markAttemptAsCheated
     * Updates apps_results_all.params to "cheated" before force exit
     */
    async markAttemptAsCheated () {
      try {
        if (!this.quizSessionId) {
          return
        }

        const payload = {
          aprs_id: this.quizSessionId,
          app_id: this.appChainIds || this.appId,
          status: "FORECLOSED"
        }

        const response = await QuizAnswers.quizAnswerSubmitForce(this, payload)
        if (!response || !response.resp_status) {
          console.error("quiz_attempt_mark_cheated failed:", response)
        }
      }
      catch (err) {
        console.error("Exception in markAttemptAsCheated() and err:", err.message)
      }
    },
    /**
     * initializeQuiz
    */
    async initializeQuiz () {
      try {
        this.route_name = this.$route.meta.name
        this.appId = this.propAppId ? this.propAppId : this.$route.params.appId

        // Read the questionIndex from localstorage, if not found, set to 0
        let qIndex = await this.questionIndexCacheGet()
        if (!qIndex) {
          qIndex = 0 // If not found in localstorage set to 0
        }
        this.questionIndexSetToIndex(qIndex)

        this.userTimeSpentAnalytics = await this.userTimeSpentAnalyticsCacheGet() ?? {}
        this.toBeReviewedQuestionIndexList = await this.toBeReviewedQuestionsCacheGet() ?? []
        this.examDetail = await this.appDetailsCacheGet() ?? {}
        this.quizSessionId = this.examDetail.quizSessionId
        this.attemptNo = this.examDetail.attemptNo
        this.appChainIds = this.examDetail.app_chain ? this.examDetail.app_chain : this.appId

        let questionListCache = await this.questionListCacheGet() ?? []
        if (questionListCache) {
          this.questionList = [...questionListCache]
        }

        // Since "await" has a lower precedence than "?." (optional chaining), used parenthesis, so that "userResponses" can be fetched before accessing the key
        this.userResponses = (await this.userResponsesCacheGet())?.userResponses ?? {}

        if (Object.keys(this.examDetail).length == 0 || this.questionList.length == 0 || Object.keys(this.userResponses).length == 0) {
          // If any of the app details or question list is missing call the backend api to populate them in local storage
          await this.quizBankList()
        }

        if (Object.keys(this.userTimeSpentAnalytics).length == 0) {
          await this.userTimeSpentAnalyticsInit()
          this.userTimeSpentAnalytics = (await this.userTimeSpentAnalyticsCacheGet()) ?? {}
        }

        const shouldTimerStart = await this.reCalculateTimer()
        if (shouldTimerStart) {
          this.startTimer()
        }

        this.refreshComponent = Math.random()
        this.$nextTick(() => {
          if (this.$refs.questionIndexDrpDwn) {
            this.$refs.questionIndexDrpDwn.value = this.questionIndex
          }
        })

        console.error("Initial userTimespentAnalytics: ", this.userTimeSpentAnalytics)
      }
      catch (err) {
        console.error("Exception in initializeQuiz() and err: ", err)
      }
    },
    /**
     * isTimeLeft
     */
    isTimeLeft () {
      let timeElapsed = moment().unix() - this.timer.exam_start_ts
      console.error("isTimeLeft:", this.questionList[this.questionIndex].qbk_id, "Exam Start On =", moment.unix(this.timer.exam_start_ts).format("YYYY-MM-DD HH:mm:ss"), "app_duration =", this.examDetail.app_duration / 60, "timeElapsed (min) =", timeElapsed / 60)
      return timeElapsed < this.examDetail.app_duration
    },
    /**
     * reCalculateTimer
     * Resets the timer based on the timestamp at which the user started to take the quiz and sets the timer accoring to the remaining time
     */
    async reCalculateTimer () {
      try {
        let timer = await this.appTimerCacheGet()
        // put the timer into the state variable of the component
        this.timer.exam_start_ts = timer.exam_start_ts

        if (!this.examDetail.has_timer) {
          return false // The quiz does not have a timer so do not start one
        }

        let timeElapsed = moment().unix() - timer.exam_start_ts
        if (timeElapsed > this.examDetail.app_duration) {
          // Quiz Timed Out
          this.showToast = true
          this.toastVariant = "danger"
          this.toastMsg = "Quiz Time out"

          // auto submit the quiz
          this.reconcileQuizAns(true)
          return false // quiz timed out, so no need to start the timer
        }
        else {
          // subtract the elapsed time from the entire exam_duration of the quiz
          const remainingTimeInSecs = this.examDetail.app_duration - timeElapsed
          this.timer.min = Math.floor(remainingTimeInSecs / 60)
          this.timer.sec = Math.floor(remainingTimeInSecs % 60)

          return true // we have some time rmaining, so start the timer
        }
      }
      catch (err) {
        console.error("Exception in reCalculateTimer() and err: ", err.message)
      }
    },

    /**
     * startTimer
     */
    startTimer () {
      this.timer.sec = this.timer.sec - 1
      if (this.timer.sec < 10 && this.timer.sec >= 0) {
        this.timer.sec = "0" + this.timer.sec
      }

      // add zero in front of numbers < 10
      if (this.timer.sec < 0) {
        this.timer.sec = "59"
      }

      // console.error("timer.sec: ", parseInt(this.timer.sec), "type: ", typeof parseInt(this.timer.sec), "timer.min: ", this.timer.min)
      if (parseInt(this.timer.sec) == 59) {
        this.timer.min = parseInt(this.timer.min) - 1
      }

      if (this.timer.min < 0 && this.timer.sec < 60) {
        // Time Out now submit paper
        this.toastVariant = "danger"
        this.toastMsg = "Quiz Time out"
        this.showToast = true

        this.reconcileQuizAns(true)
        return
      }

      this.timerFunctionRef = setTimeout(this.startTimer, 1000)

      // Commit the timer in local storage
      this.appTimerCacheSet(this.timer)
    },
    /**
     * quizBankList
     * Fetches the resuts from the backend api
     */
    async quizBankList () {
      try {
        const payload = {
          app_id: this.appId,
          aprs_id: this.quizSessionId
        }
        let quizDetailsAndQuizQuestions = await QuizBanks.quizBankList(this, payload)
        if (!quizDetailsAndQuizQuestions.resp_status) {
          ApiResponse.responseMessageDisplay(this, quizDetailsAndQuizQuestions)
          return
        }

        // set the questionList in local storage
        this.questionListCacheSet(quizDetailsAndQuizQuestions.resp_data.question_list)
        this.questionList = [...quizDetailsAndQuizQuestions.resp_data.question_list]

        // set the quizDetails in local storage
        quizDetailsAndQuizQuestions.resp_data.app_details.quizSessionId = quizDetailsAndQuizQuestions.resp_data.quizSessionId
        quizDetailsAndQuizQuestions.resp_data.app_details.attemptNo = quizDetailsAndQuizQuestions.resp_data.attemptNo
        this.appDetailsCacheSet(quizDetailsAndQuizQuestions.resp_data.app_details)

        this.examDetail = quizDetailsAndQuizQuestions.resp_data.app_details
        this.quizSessionId = quizDetailsAndQuizQuestions.resp_data.quizSessionId
        this.attemptNo = quizDetailsAndQuizQuestions.resp_data.attemptNo
        this.appChainIds = this.examDetail.app_chain ? this.examDetail.app_chain : this.appId

        // set the userResponses in local storage
        const params = JSON.parse(base64decode(quizDetailsAndQuizQuestions.resp_data.user_response))
        this.userResponses = params.userResponses
        this.userResponsesCacheSet()

        // set the value of app timer
        this.appTimerCacheSet(quizDetailsAndQuizQuestions.resp_data.timer)
      }
      catch (err) {
        console.error("Exception in quizBankList() and err: ", err.message)
      }
    },

    /**
     * userTimeSpentAnalyticsInit
     */
    async userTimeSpentAnalyticsInit () {
      try {
        const userTimeSpentAnalytics = {}
        // save the start_ts of the first question separately, cause user has viewed the first question on page load
        const currQuestionObj = this.getCurrQuestion()

        userTimeSpentAnalytics[currQuestionObj.qbk_id] = {
          q_start_ts: Math.floor(Date.now() / 1000),
          q_end_ts: 0,
          q_time_spent: this.userResponses[currQuestionObj.qbk_id].q_time_spent_last_visit ? this.userResponses[currQuestionObj.qbk_id].q_time_spent_last_visit : 0
        }

        for (let i = 1; i < this.questionList.length; i++) {
          const questionObj = this.getQuestionAtIndex(i)
          userTimeSpentAnalytics[questionObj.qbk_id] = {
            q_start_ts: 0,
            q_end_ts: 0,
            q_time_spent: this.userResponses[questionObj.qbk_id].q_time_spent_last_visit ? this.userResponses[questionObj.qbk_id].q_time_spent_last_visit : 0
          }
        }

        // commit this into local storage
        await this.userTimeSpentAnalyticsCacheSet(userTimeSpentAnalytics)
      }
      catch (err) {
        throw new Error("Failed to get user time spent analytics cache", { cause: err })
      }
    },

    // CACHE Methods
    /**
     * appTimerCacheGet
     */
    async appTimerCacheGet () {
      try {
        return await cacheLs.get_app_timer(this.appId)
      }
      catch (err) {
        throw new Error("appTimerCacheGet: ", { cause: err })
      }
    },
    /**
     * appTimerCacheSet
     */
    appTimerCacheSet (timer) {
      try {
        cacheLs.set_app_timer(this.appId, timer)
      }
      catch (err) {
        console.error(err)
        throw new Error("appTimerCacheSet: ", { cause: err })
      }
    },
    /**
     * questionIndexCacheGet
     */
    async questionIndexCacheGet () {
      try {
        return await cacheLs.get_question_index(this.appId)
      }
      catch (err) {
        throw new Error("questionIndexCacheGet: ", { cause: err })
      }
    },
    /**
     * questionIndexCacheSet
     */
    questionIndexCacheSet (timer) {
      try {
        cacheLs.set_question_index(this.appId, timer)
      }
      catch (err) {
        console.error(err)
        throw new Error("questionIndexCacheSet: ", { cause: err })
      }
    },
    /**
     * questionListCacheGet
     */
    async questionListCacheGet () {
      try {
        return await cacheLs.get_questions_list_ids_v1(this.appId)
      }
      catch (err) {
        throw new Error("questionListCacheGet: ", { cause: err })
      }
    },
    /**
     * questionListCacheSet
     */
    questionListCacheSet (questionList) {
      try {
        cacheLs.set_questions_list_ids_v1(this.appId, questionList)
      }
      catch (err) {
        console.error(err)
        throw new Error("questionListCacheSet: ", { cause: err })
      }
    },

    /**
     * appDetailsCacheGet
     */
    async appDetailsCacheGet () {
      try {
        return await cacheLs.get_quiz_app_details(this.appId)
      }
      catch (err) {
        throw new Error("appDetailsCacheGet: ", { cause: err })
      }
    },
    /**
     * appDetailsCacheSet
     */
    appDetailsCacheSet (appDetails) {
      try {
        cacheLs.set_quiz_app_details(this.appId, appDetails)
      }
      catch (err) {
        console.error(err)
        throw new Error("appDetailsCacheSet: ", { cause: err })
      }
    },

    /**
     * userResponsesCacheGet
     */
    async userResponsesCacheGet () {
      try {
        return await cacheLs.get_user_quiz_response_v1(this.appId)
      }
      catch (err) {
        throw new Error("userResponsesCacheGet: ", { cause: err })
      }
    },
    /**
     * userResponsesCacheSet
     */
    userResponsesCacheSet () {
      try {
        cacheLs.set_user_quiz_response_v1(this.appId, { userResponses: this.userResponses })
      }
      catch (err) {
        console.error(err)
        throw new Error("userResponsesCacheSet: ", { cause: err })
      }
    },

    /**
     * userTimeSpentAnalyticsCacheGet
     */
    async userTimeSpentAnalyticsCacheGet () {
      try {
        return await cacheLs.get_user_quiz_time_analytics_v1(this.appId)
      }
      catch (err) {
        throw new Error("userTimeSpentAnalyticsCacheGet: ", { cause: err })
      }
    },
    /**
     * userTimeSpentAnalyticsCacheSet
     */
    userTimeSpentAnalyticsCacheSet (userTimeSpentAnalytics) {
      try {
        cacheLs.set_user_quiz_time_analytics_v1(this.appId, userTimeSpentAnalytics)
      }
      catch (err) {
        console.error(err)
        throw new Error("userTimeSpentAnalyticsCacheSet: ", { cause: err })
      }
    },

    /**
     * toBeReviewedQuestionsCacheGet
     */
    async toBeReviewedQuestionsCacheGet () {
      try {
        return await cacheLs.get_user_to_be_reviewed_question_index_v1(this.appId)
      }
      catch (err) {
        throw new Error("toBeReviewedQuestionsCacheGet: ", { cause: err })
      }
    },

    /**
     * toBeReviewedQuestionsCacheSet
     */
    toBeReviewedQuestionsCacheSet () {
      try {
        cacheLs.set_user_to_be_reviewed_question_index_v1(this.appId, this.toBeReviewedQuestionIndexList)
      }
      catch (err) {
        console.error(err)
        throw new Error("toBeReviewedQuestionsCacheSet: ", { cause: err })
      }
    },
    // CACHE Methods

    // POINTER Methods
    // FOR QUESTION

    /**
     * getCurrQuestion
     * Returns the current question object
     */
    getCurrQuestion () {
      try {
        return this.questionList[this.questionIndex]
      }
      catch (err) {
        console.error("Exception in getCurrQuestion() and err: ", err.message)
      }
    },
    /**
     * getPrevQuestion
     */
    getPrevQuestion () {
      try {
        return this.questionList[this.questionIndex - 1]
      }
      catch (err) {
        console.error("Exception in getPrevQuestion() and err: ", err.message)
      }
    },
    /**
     * getQuestionAtIndex
     */
    getQuestionAtIndex (index) {
      try {
        return this.questionList[index]
      }
      catch (err) {
        console.error("Exception in getQuestionAtIndex() and err: ", err.message)
      }
    },
    // FOR QUESTION

    // FOR USER RESPONSES
    /**
     * getCurrUserResponse
     */
    getCurrUserResponse () {
      try {
        const questionObj = this.getCurrQuestion()
        const currUserResp = this.userResponses[questionObj.qbk_id]
        if (!currUserResp) {
          throw new Error("getCurrUserResponse: cannot  get current user response", { cause: currUserResp })
        }

        return currUserResp
      }
      catch (err) {
        console.error("Exception in getCurrUserResponse() and err: ", err.message)
      }
    },
    /**
     * getPrevUserResponse
     */
    getPrevUserResponse () {
      try {
        const questionObj = this.getPrevQuestion()
        const currUserResp = this.userResponses[questionObj.qbk_id]
        if (!currUserResp) {
          throw new Error("getPrevUserResponse: cannot  get current user response", { cause: currUserResp })
        }

        return currUserResp
      }
      catch (err) {
        console.error("Exception in getPrevUserResponse() and err: ", err.message)
      }
    },
    // FOR USER RESPONSES

    // FOR TIME SPENT ANALYTICS
    /**
     * getPrevUserTimeSpentAalytics
     */
    getPrevUserTimeSpentAalytics () {
      const prevQuestionObj = this.getPrevQuestion()
      return this.userTimeSpentAnalytics[prevQuestionObj.qbk_id]
    },

    /**
     * getPrevUserTimeSpentAalytics
     */
    getCurrUserTimeSpentAalytics () {
      const currQuestion = this.getCurrQuestion()
      return this.userTimeSpentAnalytics[currQuestion.qbk_id]
    },
    // FOR TIME SPENT ANALYTICS
    // POINTER Methods

    // USER INPUT HANDLERS
    /**
     * selectOption
     */
    selectOption (selectedOption) {
      try {
        let userRespObj = this.getCurrUserResponse()
        const questionObj = this.getCurrQuestion()

        // delete the default z option
        delete userRespObj["z"]

        if (!userRespObj[selectedOption]) {
          // select the selectedOption
          if (questionObj.answer_count > 1) {
            // question has answer in the format 'a,b' / 'a,b,c' etc
            userRespObj[selectedOption] = true
          }
          else if (questionObj.answer_count === 1) {
            // question has answer in the format 'a' / 'b' / 'c' etc
            userRespObj = { [selectedOption]: true }
          }
          else {
            return
          }
        }
        else {
          // deselect the selectedOption
          delete userRespObj[selectedOption]
          if (Object.keys(userRespObj).length == 0) {
            // If after delselection the object becomes empty, set the default 'z' option in the object
            userRespObj["z"] = true
          }
        }

        this.setCurrUserResp(userRespObj)
        this.update++
      }
      catch (err) {
        console.error("Exception in selectOption() and err: ", err.message)
      }
    },
    /**
     * setCurrUserResp
     */
    setCurrUserResp (userResp) {
      try {
        const questionObj = this.getCurrQuestion()
        this.userResponses[questionObj.qbk_id] = userResp

        // commit the changed userResponses into local storage
        this.userResponsesCacheSet()
      }
      catch (err) {
        console.error("Exception in setCurrUserResp() and err: ", err.message)
      }
    },

    /**
     * submitPrevAns
     * This function works with prev data because we move to the next question and process the previously answered question asynchronously
     */
    async submitPrevAns () {
      try {
        const prevQuestionObj = this.getPrevQuestion()
        const prevUserTimeSpentAnalytics = this.getPrevUserTimeSpentAalytics()
        const prevUserResp = this.getPrevUserResponse()

        const payload = {
          aprs_id: this.quizSessionId,
          qbk_id: prevQuestionObj.qbk_id,
          qbk_category: prevQuestionObj.qbk_category,
          app_id: this.appId,
          app_category: this.examDetail.app_category,
          answer: this.derieveUsersAns(prevQuestionObj, prevUserResp),
          q_start_ts: prevUserTimeSpentAnalytics.q_start_ts,
          q_end_ts: prevUserTimeSpentAnalytics.q_end_ts,
          q_time_spent: prevUserTimeSpentAnalytics.q_time_spent,
          user_response: base64encode(JSON.stringify({ userResponses: this.userResponses }))
        }

        if (prevUserResp.answer_image) {
          payload.answer_image = prevUserResp.answer_image
        }
        if (prevQuestionObj.answer_category) {
          payload.answer_category = JSON.parse(prevQuestionObj.answer_category)[payload.answer]
        }

        QuizAnswers.quizAnswersAdd(this, payload).then((response) => {
          if (!prevQuestionObj.is_mcq || prevQuestionObj.is_allowed_to_img_upload) {
            // set the user_responses in the cache here for FRQ and questions that require ans img upload
            if (response.resp_data.answer_image) {
              this.userResponses[response.resp_data.qbk_id].answer_image = response.resp_data.answer_image
            }
            this.userResponsesCacheSet()
          }
        })

        if (!prevQuestionObj.is_mcq || prevQuestionObj.is_allowed_to_img_upload) {
          // Reset the data variables so that a document uploaded in a question should not uploaded in the other questions
          this.answer_image_preview = null
          this.answer_image_name = null
        }
      }
      catch (err) {
        console.error("Exception in submitPrevAns() and err: ", err.message)
      }
    },
    /**
     * submitCurrAns
     */
    async submitCurrAns () {
      try {
        const currQuestionObj = this.getCurrQuestion()
        const currUserTimeSpentAnalytics = this.getCurrUserTimeSpentAalytics()
        const curruserResp = this.getCurrUserResponse()

        const payload = {
          aprs_id: this.quizSessionId,
          qbk_id: currQuestionObj.qbk_id,
          qbk_category: currQuestionObj.qbk_category,
          app_id: this.appId,
          app_category: this.examDetail.app_category,
          answer: this.derieveUsersAns(currQuestionObj, curruserResp),
          q_start_ts: currUserTimeSpentAnalytics.q_start_ts,
          q_end_ts: currUserTimeSpentAnalytics.q_end_ts,
          q_time_spent: currUserTimeSpentAnalytics.q_time_spent,
          user_response: base64encode(JSON.stringify({ userResponses: this.userResponses }))
        }

        if (curruserResp.answer_image) {
          payload.answer_image = curruserResp.answer_image
        }
        if (currQuestionObj.answer_category) {
          payload.answer_category = JSON.parse(currQuestionObj.answer_category)[payload.answer]
        }

        QuizAnswers.quizAnswersAdd(this, payload).then((response) => {
          if (!currQuestionObj.is_mcq || currQuestionObj.is_allowed_to_img_upload) {
            // set the user_responses in the cache here for FRQ and questions that require ans img upload
            if (response.resp_data.answer_image) {
              this.userResponses[response.resp_data.qbk_id].answer_image = response.resp_data.answer_image
            }
            this.userResponsesCacheSet()
          }
        })

        if (!currQuestionObj.is_mcq || currQuestionObj.is_allowed_to_img_upload) {
          // Reset the data variables so that a document uploaded in a question should not uploaded in the other questions
          this.answer_image_preview = null
          this.answer_image_name = null
        }
      }
      catch (err) {
        console.error("Exception in submitCurrAns() and err: ", err.message)
      }
    },

    /**
     * submitModalLaunch
     * Launches the Modal that shows the counts of skipped question, attempted question
     */
    submitModalLaunch () {
      let finalQuesId = this.questionList[this.questionIndex].qbk_id
      let finalQuesResp = this.userResponses[finalQuesId]

      if (!this.isQuesAttempted(finalQuesResp)) {
        // If the last question is unanswered, add 1 to the skipped, because "getSkippedQuestions" do not account for the question, student is standing at
        this.gridUnansweredQuestions = this.getSkippedQuestions(this.userResponses) + 1
      }
      else {
        this.gridUnansweredQuestions = this.getSkippedQuestions(this.userResponses)
      }
      this.gridAnsweredQuestions = this.getAttemptedQuestions(this.userResponses)
      this.showSubmitModal = true
    },

    /**
     * derieveUsersAns
     */
    derieveUsersAns (questionObj, userResp) {
      try {
        const notToBeIncludedKeys = ["answer_image"]

        if (Object.keys(userResp).length > 1) {
          // There are more keys other than option viz. 'z', 'a'; filtering keys to be excluded
          let filteredResponse = {}
          Object.keys(userResp).forEach(key => {
            if (!notToBeIncludedKeys.includes(key)) {
              filteredResponse[key] = userResp[key]
            }
          })
          if (filteredResponse.answer) {
            return filteredResponse.answer
          }

          return Object.keys(filteredResponse).sort().join(",")
        }
        else if (questionObj.is_mcq == 1) {
          return Object.keys(userResp).sort().join(",")
        }
        else {
          return userResp.answer
        }
      }
      catch (err) {
        console.error("Exception in derieveUsersAns() and err: ", err.message)
      }
    },

    /**
     * handleQuizSubmission
     */
    handleQuizSubmission (submitQuiz = false) {
      if (submitQuiz) {
        this.reconcileQuizAns()
      }
      else {
        // # The user has clicked the 'Review' button on the submit modal box
        // Do not record q_end_ts as it has been recorded when the user submits the final answer, this has been called from the submit modal box
        this.questionIndexSetToIndex(0)

        // Record the q_start_ts for the first question
        this.recordQStartTs()
        this.showSubmitModal = false
      }
    },
    /**
     * handleQuizAnalysisAndQuestionNumberGridModal
     */
    handleQuizAnalysisAndQuestionNumberGridModal () {
      // The user has clicked the 'x' button on the top right corner of the Submit modal box, record the q_start_ts of the last question
      this.recordQStartTs()
    },
    /**
     * reconcileQuizAns
     */
    async reconcileQuizAns (isQuizAutoSubmited = false) {
      try {
        if (this.examDetail.has_timer && this.timerFunctionRef) {
          clearTimeout(this.timerFunctionRef)
        }

        this.isExamSubmitted = true
        this.showSubmitLoader = true
        const payload = {
          app_id: this.appId,
          aprs_id: this.quizSessionId
        }

        if (this.appId && this.appId.includes("GPATH") && this.propModuleObject) {
          const moduleObj = this.propModuleObject || {}
          payload.gps_id = moduleObj.gps_id || null
          payload.session_state = moduleObj.session_state ?? null
          payload.session_state_desc = moduleObj.session_state_desc || null
          payload.pdt_id = moduleObj.pdt_id || null
        }

        if (isQuizAutoSubmited) {
          const currQuestion = this.getCurrQuestion()
          this.userTimeSpentAnalytics[currQuestion.qbk_id].q_end_ts = Math.floor(Date.now() / 1000)
          console.error(`reconcileQuizAns: ${currQuestion.qbk_id},  q_end_ts: ${moment.unix(this.userTimeSpentAnalytics[currQuestion.qbk_id].q_end_ts).format("YYYY-MM-DD HH:mm:ss")}`)
          this.recordQTimeSpent(currQuestion)

          payload.isQuizAutoSubmited = `TIMEOUT | ${this.getCurrQuestion().qbk_id}`
        }

        payload.userTimeSpentAnalytics = this.userTimeSpentAnalytics
        payload.userResponses = this.userResponses

        console.error("payload.userTimeSpentAnalytics ", payload.userTimeSpentAnalytics)

        QuizAnswers.quizAnswersSubmit(this, payload).then((reconcileResp) => {
          if (!reconcileResp.resp_status) {
            this.toastMsg = "Unable to submit the quiz"
            this.toastVariant = "danger"
            this.showToast = true
            this.showSubmitLoader = false
            return
          }

          this.destroyQuiz().then(() => {
            this.exitQuiz()
          }).catch((err) => {
            console.error("Exception in destroyQuiz() and err: ", err)
            this.showSubmitLoader = false
          })
        }).catch((err) => {
          console.error("Exception in quizAnswersSubmit api and err: ", err)
          this.showSubmitLoader = false
        })
      }
      catch (err) {
        this.showSubmitLoader = false
        console.error("Exception in reconcileQuizAns() and err: ", err.message)
      }
    },
    /**
     * destroyQuiz
     * cleans up the local storage out of quiz data
     */
    async destroyQuiz () {
      await cacheLs.remove_user_quiz_response_v1(this.appId)
      await cacheLs.remove_questions_list_ids_v1(this.appId)
      await cacheLs.remove_user_quiz_time_analytics_v1(this.appId)
      await cacheLs.remove_user_to_be_reviewed_question_index_v1(this.appId)
      await cacheLs.remove_quiz_app_details(this.appId)
      await cacheLs.remove_app_timer(this.appId)
      await cacheLs.remove_question_index(this.appId)
    },
    /**
     * exitQuiz
     */
    exitQuiz () {
      try {
        this.exitingQuiz = true
        this.showSubmitLoader = false

        if (this.propAppId) {
          this.$emit("emitNextTab", { resp_status: true })
        }
        else if (this.route_name == "gpath_home") {
          // For Some Reason like Slow Browser/Laptop, the appId. In case of GPATHS QUIZes if the appId is not set in the mounted() hook, so we are emitting the event to the parent component to move to the next tab
          this.$emit("emitNextTab", { resp_status: true })
        }
        else {
          if (this.examDetail.break_before_chained_app_id) {
            this.$router.replace(`/quiz_break/${this.examDetail.chained_app_id}`)
          }
          else if (this.examDetail.chained_app_id) {
            // Check if another quiz is chained. if found then open that chained quiz else the result
            this.$router.replace(`/quiz_detail/${this.examDetail.chained_app_id}`)
          }
          else {
            // SET THE APPROPRIATE CODE
            let code = "thankyou"
            if (this.examDetail.app_name.includes("GPaths Impact Assessment Survey")) {
              code = "GPATHS_THANK_YOU"
            }
            else if (this.examDetail.app_name.includes("Survey")) {
              code = "thankyou"
            }
            else if (this.examDetail.app_name.toUpperCase().includes("AP")) {
              code = "AP"
            }

            // REDIRECT IF FLAG CONFIGURED IN DB
            if (this.examDetail.app_redirect_to_thankyou_page_to_other) {
              this.$router.replace(`/thankyou?redirect=${btoa(this.examDetail.app_redirect_to_thankyou_page_to_other)}`)
            }
            else if (this.examDetail.redirect_to_thankyou_page) {
              this.$router.replace(`/thankyou?code=${code}`)
            }
            else {
              if (this.examDetail.app_type.toLowerCase() == "testseries") {
                this.$router.replace(`/app_result_analyse_v1/${this.appId}/${this.userData.user_id}/${this.quizSessionId}?attempt=${this.attemptNo}`)
              }
              else if (this.examDetail.app_name.toLowerCase().includes("mock") || this.examDetail.app_name.toLowerCase().includes("-a-thon") || this.examDetail.app_name.toLowerCase().includes("diagnostic")) {
                this.$router.replace(`/app_result_view_v1/${this.appId}/${this.userData.user_id}/${this.quizSessionId}/${this.attemptNo}`)
              }
              else {
                this.$router.replace(`/app_result_view/${this.appId}/${this.userData.user_id}/1`) // 0: dont Show, 1: Show:: info message on top of the result page
              }
            }
          }
        }
      }
      catch (err) {
        console.error("Exception in exitQuiz() and err: ", err)
      }
    },

    // ANALYTICS RELATED FUNCTIONS
    /**
     * isQuesAttempted
     */
    isQuesAttempted (userRespObj) {
      if (!userRespObj || typeof userRespObj !== "object") {
        // When User double clicks on an option userRespObj is NULL. As a result the next button and other actions on the page freezes. so dont process and return
        return false
      }

      if (Object.keys(userRespObj).includes("answer")) {
        // ESSAY TYPE
        const hasAnswer = userRespObj["answer"] || typeof userRespObj["answer"] == "number"
        const hasImage = userRespObj["answer_image"] && userRespObj["answer_image"] !== null

        // If z is explicitly false, it's attempted
        if (userRespObj["z"] === false) {
          return true
        }

        // Check for text answer or image
        if (hasAnswer || hasImage) {
          return true
        }

        return false
      }
      else if (userRespObj["z"] === undefined || userRespObj["z"] === false) {
        // MCQ, attempted (z is undefined or false means attempted)
        return true
      }
      else {
        // z is true (unanswered) unattempted, be it MCQ / ESSAY TYPE
        return false
      }
    },
    /**
     * getAttemptedQuestions
     */
    getAttemptedQuestions (userResponses) {
      let attemptedQuestionsList = Object.keys(userResponses).filter(qbkId => {
        return this.isQuesAttempted(userResponses[qbkId])
      })
      return attemptedQuestionsList.length
    },
    /**
     * getSkippedQuestions
     * ANALYTICS RELATED FUNCTIONS
     */
    getSkippedQuestions (userResponses) {
      // No. of attempted questions till the current question's index
      let attemptedQuestions = 0
      for (let i = 0; i < this.questionIndex; i++) {
        let qbkId = this.questionList[i].qbk_id

        if (this.isQuesAttempted(userResponses[qbkId])) {
          attemptedQuestions++
        }
      }

      let noOfSkippedQuestions = (this.questionIndex) - attemptedQuestions
      return noOfSkippedQuestions >= 0 ? noOfSkippedQuestions : 0
    },
    /**
     * goTo Quiz Detail
     */
    async goToQuizDetail () {
      this.$router.push(`/quiz_detail/${this.appId}`)
      // this.handleQuitAttempt()
    },
    /**
     * getOptionColor
     * CSS SETTERS
     */
    getOptionColor (qbkId) {
      const response = this.userResponses[qbkId]

      // Check if z is true (unanswered/skipped)
      if (response["z"] === true) {
        // Question marked as skipped
        if (Object.keys(response).includes("answer")) {
          // Essay type question
          const hasAnswer = response["answer"] || typeof response["answer"] == "number"
          const hasImage = response["answer_image"] && response["answer_image"] !== null

          // If either text answer OR image is present, mark as attempted (blue)
          if (hasAnswer || hasImage) {
            // Answered
            return "#3366CC !important"
          }
          else {
            // Unanswered
            return "#888 !important"
          }
        }

        // MCQ question marked as skipped (z = true)
        // Unanswered
        return "#888 !important"
      }

      // z is false or undefined (answered/attempted)
      // Answered
      return "#3366CC !important"
    },
    // CSS SETTERS
    /**
     * makeDraggable
     */
    makeDraggable () {
      this.$nextTick(() => {
        const modal = document.querySelector("#DemosCal .modal-dialog")
        const header = modal.querySelector(".modal-header")

        let isDragging = false
        let offsetX = 0
        let offsetY = 0

        header.style.cursor = "move"

        // --- Desktop events (mouse) ---
        header.onmousedown = (e) => {
          e.preventDefault()
          startDragging(e.clientX, e.clientY)
        }

        // --- Mobile events (touch) ---
        header.addEventListener("touchstart", (e) => {
          const touch = e.touches[0]
          startDragging(touch.clientX, touch.clientY)
        }, { passive: false })

        function startDragging (x, y) {
          isDragging = true
          offsetX = x - modal.offsetLeft
          offsetY = y - modal.offsetTop

          document.onmousemove = (e) => {
            if (isDragging) {
              moveModal(e.clientX, e.clientY)
            }
          }

          document.addEventListener("touchmove", (e) => {
            if (isDragging) {
              e.preventDefault()
              const touch = e.touches[0]
              moveModal(touch.clientX, touch.clientY)
            }
          }, { passive: false })

          document.onmouseup = stopDragging
          document.addEventListener("touchend", stopDragging, { passive: false })
        }

        function moveModal (x, y) {
          modal.style.position = "absolute"
          modal.style.margin = 0
          modal.style.left = x - offsetX + "px"
          modal.style.top = y - offsetY + "px"
          modal.style.width = "100%"
        }

        function stopDragging () {
          isDragging = false
          document.onmousemove = null
          document.onmouseup = null
          document.ontouchmove = null
          document.ontouchend = null
        }
      })
    },
    /**
     * prev
     */
    async prev () {
      // Record end_ts of the current question
      this.recordQEndts()

      // Submit the current question
      await this.submitCurrAns()

      // Move to the previous question
      this.questionIndexDecrement()

      // Record start_ts of the question we moved in the last step
      this.recordQStartTs()
    },
    /**
     * next
     */
    async next () {
      this.recordQEndts()
      if (this.questionIndex < this.questionList.length - 1) {
        this.questionIndexIncrement()

        // record the q_start_ts of the next question as the questionIndex is incremented
        this.recordQStartTs()
        await this.submitPrevAns()
      }
      else {
        await this.submitCurrAns()
        this.submitModalLaunch()
      }
    },
    /**
     * questionIndexIncrement
     */
    questionIndexIncrement () {
      this.questionIndex++

      // commit the questionIndex into localstorage
      this.questionIndexCacheSet(this.questionIndex)
    },
    /**
     * questionIndexDecrement
     */
    questionIndexDecrement () {
      this.questionIndex--

      // commit the questionIndex into localstorage
      this.questionIndexCacheSet(this.questionIndex)
    },
    /**
     * questionIndexSetToIndex
     * Set the questionIndex pointer to a given indes
     */
    questionIndexSetToIndex (index) {
      this.questionIndex = Number(index)

      // commit the questionIndex into localstorage
      this.questionIndexCacheSet(this.questionIndex)
    },
    /**
     * recordQEndts
     * Records q_end_ts of the current question always, if user has enough time left
     */
    recordQEndts () {
      if (this.isTimeLeft()) {
        const currQuestion = this.getCurrQuestion()
        this.userTimeSpentAnalytics[currQuestion.qbk_id].q_end_ts = Math.floor(Date.now() / 1000)
        console.error(`recordQEndts: ${currQuestion.qbk_id},  q_end_ts: ${moment.unix(this.userTimeSpentAnalytics[currQuestion.qbk_id].q_end_ts).format("YYYY-MM-DD HH:mm:ss")}`)
        this.recordQTimeSpent(currQuestion)
      }
    },
    /**
     * recordQStartTs
     * Record the q_start_ts of the next question always, if user has enough time left
     */
    recordQStartTs () {
      if (this.isTimeLeft()) {
        const currQuestion = this.getCurrQuestion()
        this.userTimeSpentAnalytics[currQuestion.qbk_id].q_start_ts = Math.floor(Date.now() / 1000)
        console.error(`recordQStartTs: ${currQuestion.qbk_id},  q_start_ts: ${moment.unix(this.userTimeSpentAnalytics[currQuestion.qbk_id].q_start_ts).format("YYYY-MM-DD HH:mm:ss")}`)
        // commit the user time spent analytics
        this.userTimeSpentAnalyticsCacheSet(this.userTimeSpentAnalytics)
      }
    },
    /**
     * recordQTimeSpent
     */
    recordQTimeSpent (question = null) {
      if (!question) {
        console.error("recordQTimeSpent: Something went wrong: current question object cannot be null")
        this.userTimeSpentAnalytics[question.qbk_id].q_time_spent += 0
      }
      else {
        console.error(`recordQTimeSpent: ${question.qbk_id},  q_end_ts: ${moment.unix(this.userTimeSpentAnalytics[question.qbk_id].q_end_ts).format("YYYY-MM-DD HH:mm:ss")}, q_start_ts: ${moment.unix(this.userTimeSpentAnalytics[question.qbk_id].q_start_ts).format("YYYY-MM-DD HH:mm:ss")}, last_visit_q_time_spent: ${this.userTimeSpentAnalytics[question.qbk_id].q_time_spent}, current_q_time_spent: ${(this.userTimeSpentAnalytics[question.qbk_id].q_end_ts - this.userTimeSpentAnalytics[question.qbk_id].q_start_ts)}`)
        this.userTimeSpentAnalytics[question.qbk_id].q_time_spent += (this.userTimeSpentAnalytics[question.qbk_id].q_end_ts - this.userTimeSpentAnalytics[question.qbk_id].q_start_ts)
      }

      // set the q_time_spent_last_visit, in this.userResponses so that they can be cached on the backend
      this.userResponses[question.qbk_id].q_time_spent_last_visit = this.userTimeSpentAnalytics[question.qbk_id].q_time_spent

      // commit the user time spent analytics
      this.userTimeSpentAnalyticsCacheSet(this.userTimeSpentAnalytics)

      // commit the time spent into user responses as it is being cached inside the same object on the backend
      this.userResponsesCacheSet()
    },

    /**
     * imgModal
     */
    imgModal (quesObj) {
      try {
        this.propImageUrl = quesObj
        this.showModelImageView = true
      }
      catch (err) {
        console.error("Exception occurred at imgModal() and Exception:", err.message)
      }
    },
    /**
     * showModelReportFn
     */
    showModelReportFn (moduleObjId, moduleName) {
      this.reportModuleObjId = moduleObjId
      this.reportModuleName = moduleName
      this.showReportIssueModalBox = true
    },
    /**
     * closeReportAddModal
     */
    closeReportAddModal () {
      this.showReportIssueModalBox = false
    },
    /**
     * markQuestionForReview
     */
    markUnmarkQuestionForReview () {
      if (!this.toBeReviewedQuestionIndexList.includes(Number(this.questionIndex))) {
        // mark
        this.toBeReviewedQuestionIndexList.push(Number(this.questionIndex))
      }
      else {
        this.toBeReviewedQuestionIndexList.splice(this.toBeReviewedQuestionIndexList.findIndex((e) => e == Number(this.questionIndex)), 1)
      }

      this.toBeReviewedQuestionsCacheSet()
    },
    /**
     * jumpToQuestion
     */
    async jumpToQuestion (event) {
      // Record the q_end_ts of the current question before jumping
      this.recordQEndts()

      // submit the current question
      await this.submitCurrAns()

      this.questionIndexSetToIndex(event.target.value)

      // Record the q_start_ts of the question the user has jumped to
      this.recordQStartTs()
    },
    /**
      closeSubmitModalAndGoToQuestion
    */
    closeSubmitModalAndGoToQuestion (qIndex) {
      // # The user has clicked one of the questions from the 'grid' on the submit modal box
      // Do not record q_end_ts as it has been recorded when the user submits the final answer, this has been called from the submit modal box
      this.questionIndexSetToIndex(qIndex)

      // Record the q_start_ts for the question selected from the grid
      this.recordQStartTs()
      this.showSubmitModal = false
    },

    /**
     * chatBotclose
     */
    chatBotclose () {
      this.isChatBotOpen = false
    },
    /**
     * validate Numeric Input. Allowed - Numbers 0-9 / . ^ -
     */
    validateNumericInput (event) {
      // console.log(this.questionList[this.questionIndex].qbk_id, "XXXXXXX0", this.questionList[this.questionIndex].is_essay_type_numeric)
      if (this.questionList[this.questionIndex].is_essay_type_numeric === 1) {
        // allowed: digits 0-9 and symbols / . ^ -
        const allowed = /[0-9/.^-]/
        const key = String.fromCharCode(event.which)

        if (!allowed.test(key)) {
          event.preventDefault() // block invalid key
        }
      }
    },
    /**
     * NOT IN USE BUT CAN BE ENABLED IN FUTURE
     * isNumericAnsMaxLenExceeded
     * Numeric answers allow up to 5 characters for positive and 6 characters (including the negative sign) for negative answers
     */
    isNumericAnsMaxLenExceeded (inputEle, key) {
      const selectionStart = inputEle.selectionStart ?? inputEle.value.length
      const selectionEnd = inputEle.selectionEnd ?? inputEle.value.length
      const newValue = inputEle.value.slice(0, selectionStart) + key + inputEle.value.slice(selectionEnd)
      const maxLength = newValue.startsWith("-") ? NUMERIC_ANS_MAX_LEN_NEGATIVE : NUMERIC_ANS_MAX_LEN_POSITIVE

      return newValue.length > maxLength
    },
    /**
     * on Ans Img Attatachment Change
     *
     */
    onAnsImgAttatachmentChange (event, answerImage, inputId) {
      const fileList = event.target.files

      if (fileList && fileList.length) {
        const file = fileList[0]
        // Allowed file types
        let allowedExtensions = this.allowedExtensions.split(",")
        let maxSize = 5 * 1024 * 1024 // 5MB limit

        if (!allowedExtensions.includes(file.type)) {
          this.toastMsg = "Invalid file type. Please upload a supported file."
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        if (file.size > maxSize) {
          this.toastMsg = "File size exceeds the 5MB limit."
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        // Store the file object directly (binary)
        answerImage.answer_image = file

        // Set z: false to mark question as answered
        answerImage["z"] = false

        // Store filename for display
        this.answer_image_name = file.name

        // Optional: Store preview URL for display
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = async (e) => {
          this.answer_image_preview = e.currentTarget.result
        }
      }
    },
    /**
     * removeImage
     */
    removeImage (inputId) {
      if (this.userResponses[this.questionList[this.questionIndex].qbk_id]) {
        this.$set(this.userResponses[this.questionList[this.questionIndex].qbk_id], "answer_image", null)
      }

      // clear preview and name
      this.answer_image_preview = ""
      this.answer_image_name = ""

      // Reset input field
      const ele = document.getElementById(inputId)
      if (ele) {
        ele.value = ""
      }
    },
    /**
     * openFile
     * Handle both S3 URLs and base64 data URLs
     */
    openFile (url) {
      if (url === "") {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "This document can only be viewed after accepting the application"
        return
      }

      // Check if it's a base64 data URL (staged preview)
      if (url.startsWith("data:")) {
        try {
          // Convert base64 to blob and create a temporary URL
          const arr = url.split(",")
          const mime = arr[0].match(/:(.*?);/)[1]
          const bstr = atob(arr[1])
          let n = bstr.length
          const u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          const blob = new Blob([u8arr], { type: mime })
          const blobUrl = URL.createObjectURL(blob)
          window.open(blobUrl, "_blank")

          // Clean up the blob URL after a short delay
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100)
        }
        catch (err) {
          console.error("Error opening base64 file:", err)
          this.showToast = true
          this.toastVariant = "danger"
          this.toastMsg = "Unable to open the file. Please try again."
          this.showToast = true
        }
      }
      else {
        // It's a regular S3 URL
        window.open(url, "_blank")
      }
    },
    /**
     * save And Next
     */
    submitTextFromModal () {
      this.showAnswerModal = false
      setTimeout(() => this.next(), 1000)
    }
  },
  watch: {
    questionIndex (newVal) {
      // On mounted the element is sometimes not present, so check the existence of the ref, before setting its value
      if (this.$refs.questionIndexDrpDwn) {
        this.$refs.questionIndexDrpDwn.value = newVal
      }
    }
  }
}
